import { BaseDataService } from "app/core/services/base-data.service";
import { CityOfHealth } from "../models/city-of-health.interface";
import { Injectable } from "@angular/core";
import { API_MAP } from "app/core/helpers/api.map";
import { Observable, tap } from "rxjs";
import { Result } from "app/core/models/result";

@Injectable()
export class CityOfHealthService extends BaseDataService<CityOfHealth>{
 override controller = API_MAP.locations;

  override get(controller?: string): Observable<Result<any>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }
}